<template>
  <div>
    <div class="card bg-white rounded">
      <vs-row class="mb-2">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="12">
          <feather-icon
            class="mr-4"
            icon="FileTextIcon"
            svgClasses="text-black stroke-current w-36.96 h-36.96"
          ></feather-icon>
          <h1 class="md:lg m-0">Informações Básicas</h1>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="12">
          <span class="my-2 md:text-base"
            >Preencha seu cadastro completo. Seu perfil só poderá ser visualizado caso vá
            até o final do cadastro.</span
          >
        </vs-col>
      </vs-row>

      <vs-row>
        <vs-col vs-w="6" vs-xs="12" vs-sm="12">
          <vs-input
            class="w-full no-icon-border mb-1"
            v-model="payload.name"
            name="nome"
            type="text"
            label="Nome *"
            v-validate="'required|min:3|max:80'"
            data-vv-validate-on="blur"
            @blur="doCaclulateProgress"
          />
          <span class="text-danger text-sm">{{ errors.first("nome") }}</span>
        </vs-col>

        <vs-col vs-w="6" vs-xs="12" vs-sm="12" class="my-0">
          <label class="vs-input--label" for="phonenumber"> Telefone* </label>
          <VuePhoneNumberInput
            id="phonenumber"
            default-country-code="BR"
            v-model="payload.telephone"
            valid-color="#000000"
            :style="{ opaticy: 0.2 }"
            :translations="{
              countrySelectorLabel: 'Código',
              countrySelectorError: 'Selecione um País',
              phoneNumberLabel: 'Número de Telefone',
              example: 'Exemplo:',
            }"
          />
        </vs-col>

        <vs-col class="my-5" vs-w="6" vs-xs="12" vs-sm="12">
          <div class="flex items-center my-2">
            <label class="vs-select--label">Pronome</label>
            <Tooltip :text="pronoun_tooltip" />
          </div>
          <v-select
            placeholder="Escolha uma opção"
            v-model="payload.pronoun_id"
            :reduce="(pronoun) => pronoun.value"
            :options="pronouns"
          />
        </vs-col>

        <!-- TODO: Descomentar em uma próxima versão  -->
        <!-- <vs-col
          :class="include_social_name ? 'my-5' : 'my-10'"
          vs-w="6"
          vs-xs="12"
          vs-sm="12"
        >
          <vs-col v-if="!include_social_name" class="flex" vs-w="12">
            <vs-switch color="primary" v-model="include_social_name" />
            <p class="ml-4">Incluir campo de Nome Social</p>
            <Tooltip
              :text="social_name_tooltip"
              :position="isMobile ? 'bottom-right' : 'bottom-left'"
            />
          </vs-col>

          <div v-if="include_social_name">
            <div class="flex items-center my-2">
              <label class="vs-select--label">Nome Social</label>
              <Tooltip
                :text="social_name_tooltip"
                :position="isMobile ? 'bottom-right' : 'bottom-left'"
              />
            </div>
            <vs-input
              v-show="include_social_name"
              class="w-full no-icon-border mb-1"
              type="text"
              placeholder="Insira aqui o seu nome social"
              v-model="payload.social_name"
            />
          </div>
        </vs-col> -->

        <vs-col :class="isMobile ? 'mt-2' : 'mt-8'" vs-w="6" vs-xs="12" vs-sm="12">
          <vs-input
            ref="birthdayField"
            class="w-full no-icon-border mb-1"
            name="nascimento"
            type="tel"
            label="Data de nascimento *"
            v-mask="'##/##/####'"
            v-validate="'required|birthday'"
            data-vv-validate-on="blur"
            placeholder="Exemplo: 06/10/1995"
            v-model="payload.birthday"
            @blur="doCaclulateProgress"
          />
          <span class="text-danger text-sm">{{ errors.first("nascimento") }}</span>
        </vs-col>

        <vs-col vs-w="6" vs-xs="12" vs-sm="12">
          <validation-provider
            name="linkedin_url"
            rules="linkedin_domain"
            v-slot="{ errors }"
            mode="lazy"
          >
            <vs-input
              class="w-full no-icon-border mb-1"
              v-model="payload.linkedin_url"
              name="linkedin_url"
              type="text"
              placeholder="https://linkedin.com/in/seu-perfil"
              label="Link (URL) do Linkedin (Opcional)"
              @blur="doCaclulateProgress"
              :danger="errors.length > 0"
              :danger-text="errors[0]"
            />
          </validation-provider>
        </vs-col>

        <vs-col vs-w="6" vs-xs="12" vs-sm="12">
          <validation-provider
            name="remuneration"
            v-slot="{ errors }"
            mode="lazy"
          >
            <vs-input
              class="w-full no-icon-border mb-1"
              v-model="payload.remuneration"
              name="remuneration"
              type="text"
              label="Pretensão salarial (Opcional)"
              @input="handleMaskRemuneration"
              :danger="errors.length > 0"
              :danger-text="errors[0]"
            />
          </validation-provider>
        </vs-col>

        <vs-col class="mt-5" vs-w="6" vs-xs="12" vs-sm="12">
          <div class="file">
            <label for="file-input" :style="{ borderColor: color, color }">
              Insira seu Currículo
            </label>
            <input
              id="fileCV"
              ref="fileCV"
              type="file"
              accept="application/pdf,application/msword,.doc,.docx,.pdf"
              @change="handleCVUpload"
            />
          </div>
          <div class="flex items-center my-4">
            <div class="flex my-1 items-center">
              <feather-icon
                v-if="CvUploaded"
                svgClasses="text-success"
                icon="CheckIcon"
              />
              <feather-icon v-else svgClasses="text-danger" icon="XIcon" />
              {{
                `${
                  !CvUploaded
                    ? "Você ainda não adicionou o currículo!"
                    : "Seu Currículo foi adicionado!"
                }`
              }}
            </div>
          </div>
        </vs-col>

        <vs-col class="my-1 mt-5" vs-w="6" vs-xs="12" vs-sm="12">
          <div class="file">
            <label for="file-input" :style="{ borderColor: color, color }"
              >Escolha uma Foto</label
            >
            <input
              id="file"
              ref="file"
              type="file"
              accept=".jpg,.jpeg,.png"
              v-on:change="handleFileUpload()"
            />
          </div>
          <div class="flex items-center my-4">
            <div>
              <div v-if="!onEditMode()" class="my-1 flex items-center">
                <feather-icon
                  v-if="!shouldDisplaySuccess()"
                  svgClasses="text-danger"
                  icon="XIcon"
                />
                <feather-icon v-else svgClasses="text-success" icon="CheckIcon" />
                {{
                  `${
                    !fileUpload
                      ? "Você ainda não adicionou nenhuma foto"
                      : "Sua Foto foi adicionada."
                  }`
                }}
              </div>
              <div v-if="onEditMode()" class="my-1 flex items-center">
                <feather-icon
                  v-if="!shouldDisplaySuccess()"
                  svgClasses="text-danger"
                  icon="XIcon"
                />
                <feather-icon v-else svgClasses="text-success" icon="CheckIcon" />
                {{
                  `${
                    !fileUpload
                      ? "Você ainda não adicionou nenhuma foto"
                      : "Foto adicionada. clique em atualizar para fazer o envio"
                  }`
                }}
              </div>
            </div>
          </div>
        </vs-col>
      </vs-row>
    </div>

    <div class="flex flex-wrap mt-2">
      <backward-button @click="handleBackward" />
      <forward-button @click="handleForward" />
    </div>

    <vs-popup title="" :active.sync="alert">
      <div class="popup-container">
        <h2 style="text-align: center">Seja bem-vindo(a) ao processo de candidatura!</h2>
        <div class="popup-container--image">
          <img
            src="@/assets/images/undraw_fitting_piece_re_pxay 1.svg"
            alt="Mulher negra mexendo em objetos abstratos."
          />
        </div>
        <p style="text-align: center">
          Aqui inicia sua inscrição na vaga. Seu perfil só será visível pelo contratante
          ao final deste cadastro, incluindo possíveis perguntas da empresa. Ao finalizar
          sua candidatura, não esqueça de realizar seu teste de perfil comportamental, que
          é extremamente importante para seu autoconhecimento.
        </p>
        <div class="popup-container--actions">
          <vs-button @click="handleReview">Completar meus Dados</vs-button>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import axios from "axios";
import { isEmpty, get, set, keys } from "lodash";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";

/* eslint-disable */
import { mapState, mapActions } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { ModelSelect } from "vue-search-select";
import vSelect from "vue-select";
import MobileFooter from "@/layouts/components/mobile-footer/MobileFooter";
import Tooltip from "../../components/tooltip/Tooltip.vue";
import ForwardButton from "@/components/ForwardButton";
import BackwardButton from "@/components/BackwardButton";

export default {
  components: {
    VuePhoneNumberInput,
    ModelSelect,
    MobileFooter,
    ForwardButton,
    BackwardButton,
    "v-select": vSelect,
    ValidationProvider,
    ValidationObserver,
    Tooltip,
  },
  data: () => ({
    isMobile: false,
    maritalStatusChoices: [
      { value: "Solteiro(a)", label: "Solteiro(a)" },
      { value: "Casado(a)", label: "Casado(a)" },
      { value: "Divorciado(a)", label: "Divorciado(a)" },
      { value: "Viúvo(a)", label: "Viúvo(a)" },
      { value: "Separado(a)", label: "Separado(a)" },
    ],
    payload: {
      ssn: "",
      name: "",
      birthday: "",
      telephone: "",
      linkedin_url: "",
      pronoun_id: "",
      social_name: "",
      curriculum_filename: "",
      remuneration: "",
    },
    pronoun_tooltip:
      "Queremos saber qual é o pronome que você prefere para que a gente use o pronome certo de acordo com o seu gênero. Isso é importante para respeitar a sua identidade.",
    social_name_tooltip:
      "No processo seletivo perguntamos qual é o nome que você quer ser chamado, mesmo que não seja o nome que está no documento de identidade. Assim, podemos respeitar sua identidade de gênero e ajudar a criar um ambiente de trabalho mais inclusivo para pessoas trans e não-binárias.",
    pronouns: [],
    include_social_name: false,
    fileUpload: false,
    CvUploaded: false,
    fileCV: undefined,
    alert: false,
  }),
  mounted() {
    this.alert = true;

    if (window.innerWidth <= 768) {
      this.isMobile = true;
    }
  },
  watch: {
    "payload.gender": function (newVal, oldVal) {
      if (newVal === null) {
        this.payload.gender = null;
      }
    },
    basicFormSubmit({ trigger }) {
      if (trigger === true) {
        this.handleForward();
      }
    },
  },
  computed: {
    ...mapState("basicInfo", ["basicInfo"]),
    ...mapState("auth", ["auth"]),
    color() {
      return this.$store.state.company.company.base_hexcolor || "#1551b1";
    },
    ...mapState({
      basicFormSubmit: state => state.step.basicFormSubmit
    }),
  },
  methods: {
    ...mapActions("basicInfo", [
      "setBasicInfo",
      "meBasic",
      "addUpdatePhotoUrl",
      "addCurriculumUrl"
    ]),
    ...mapActions("progress", ["calculateProgress"]),

    async handleForward() {
      const isValid = await this.$validator.validate();
      if (!isValid) {
        await this.$store.dispatch("step/basicFormSubmit", { trigger: false, goTo: undefined });
        const firstErrorField = this.errors.items[0].field;
        const firstErrorElement = document.querySelector(`[name="${firstErrorField}"]`);
        if (firstErrorElement) {
            firstErrorElement.focus();
        }
        return;
      }

      this.$vs.loading({ text: "Enviando..." });

      const { company_label } = this.$router.history.current.params;

      this.$http
      .post('/api/v1/diversity', {
          ...this.$store.state.diversity,
          social_name: this.payload.social_name,
          pronoun_id: this.payload.pronoun_id
        })
        .then(response => {
          this.$store.dispatch('diversity/addDiversity', response.data);
        })

      this.$http
        .post(`api/v1/talent/${company_label}/user/talent?step=basic`, {
          basicInfo: { 
            ...this.payload,
            remuneration: parseFloat(this.payload.remuneration.replaceAll('.', '').replace(',', '.'))
          },
        })
        .then(async (response) => {
          this.$vs.loading.close();

          this.$store.dispatch("basicInfo/store", {
            ...this.payload,
          });

          if (this.onEditMode()) {
            this.$router.push({
              name: "dashboard-profile-detail",
            });
            return;
          }

          await this.$store.dispatch("step/completeStep");

          if (this.basicFormSubmit.trigger === true && typeof this.basicFormSubmit.goTo === 'number') {
            await this.$store.dispatch("step/updateCurrentStep", {
              order: this.basicFormSubmit.goTo
            });
          } else {
            await this.$store.dispatch("step/incrementCurrentStep");
          }
          await this.$store.dispatch("step/completeStep");

          const { path } = this.$store.getters["step/current"];

          const { params } = this.$router.history.current;

          this.$router.push({
            name: path,
            params,
          });
        })
        .catch(() => {
          this.$vs.loading.close();
        });
        await this.$store.dispatch("step/basicFormSubmit", { trigger: false, goTo: undefined });
    },

    async handleBackward() {
      if (this.onEditMode()) {
        this.$router.push({
          name: "dashboard-profile-detail",
        });
        return;
      }

      await this.$store.dispatch("step/decrementCurrentStep");

      const { path } = this.$store.getters["step/current"];

      const { params } = this.$router.history.current;

      this.$router.push({
        name: path,
        params,
      });
    },

    shouldDisplaySuccess() {
      return this.fileUpload;
    },

    onEditMode() {
      const currentPath = this.$router.history.current.name;
      return currentPath.slice(0, 4) == "edit";
    },

    async handleFileUpload() {
      const file = this.$refs.file.files[0];

      if (file !== null || file !== undefined) {
        try {
          const { company_label } = this.$router.history.current.params;

          this.$vs.loading({
            text: "Salvando...",
          });

          const formData = new FormData();
          formData.append("photo_filename", file);

          const response = await this.$http.post(
            `api/v1/talent/${company_label}/user/talent/upload/photo`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          );

          this.$vs.loading.close();

          if (response.status === 200) {
            this.fileUpload = true;
            this.payload = {
              ...this.payload,
              photo_url: response.data["photo_filename"],
            };
            this.addUpdatePhotoUrl(response.data["photo_filename"]);
          }
        } catch (error) {
          this.$vs.loading.close();

          this.$vs.notify({
            title: "Falha ao enviar foto",
            text:
              error.message ||
              "Falha ao realizar o procedimento contate a nossa equipe de suporte",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
          });
        }
      }
    },

    handleCVUpload: function () {
      this.$vs.loading({
        text: "Enviando...",
      });

      const { company_label } = this.$router.history.current.params;

      const file = this.$refs.fileCV.files[0];
      const formData = new FormData();

      formData.append("curriculum_filename", file);

      const token = this.$store.getters["auth/token"];

      axios
        .post(
          `${process.env.VUE_APP_CURRICULUM_SERVICE}/api/v1/talent/${company_label}/user/talent/upload/curriculum?debug=true`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((response) => {
          this.$vs.loading.close();

          this.CvUploaded = true;
          this.payload.curriculum_filename = response.data["curriculum_filename"];
          this.payload.curriculum_url = response.data["curriculum_filename"];
          this.$store.dispatch(
            "basicInfo/addCurriculumUrl",
            response.data["curriculum_filename"]
          );
          this.addCurriculumUrl(response.data["curriculum_filename"]);
          if(response.data["validate"]["result"] === false ){
            this.$vs.notify({
              title: "O Currículo foi salvo, Porém...",
              text: response.data["validate"]["message"] || "Porém, o arquivo enviado não parece ser um Currículo.",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "warning",
              time: 5000
            });
          }
          window.woopra.track("curriculum-uploaded", {
            curriculum_filename: response.data["curriculum_filename"],
            valid: response.data["validate"]["result"],
            valid_msg: (response.data["validate"]["result"] === false) ? response.data["validate"]["message"] : null
          });
        })
        .catch((error) => {
          this.$vs.loading.close();

          if (error.response === undefined) {
            this.$vs.notify({
              title: "Falha ao enviar curriculo",
              text:
                "O tamanho máximo do arquivo é de 15MB!" ||
                "Ocorreu um erro ao enviar o currículo. Atualize a página e tente novamente!",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          } else {
            this.$vs.notify({
              title: "Falha ao enviar curriculo",
              text:
                error.response.data.errors[0].errors ||
                "Ocorreu um erro ao enviar o currículo. Atualize a página e tente novamente!",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },

    uploadedFile: function () {
      const { updated } = this.$router.history.current.query;
      this.CvUploaded = parseInt(updated);
    },

    checkCurriculumUrlBasicInfo: function () {
      this.CvUploaded = this.basicInfo.curriculum_url ? true : false;
    },

    doCaclulateProgress(e) {
      this.calculateProgress({ field: e.target.name, value: e.target.value });
    },

    handleReview() {
      this.alert = false;
      const top = element.offsetTop;
      window.scrollTo(0, top);
    },

    handleMaskRemuneration(value){
      const maskedValue = this.formatCurrency(value)
      this.payload.remuneration = maskedValue
    },

    formatCurrency(e) {
      let value = e;
      value = value.replace(/\D/g, "");
      value = value.replace(/(\d)(\d{2})$/, "$1,$2");
      value = value.replace(/(?=(\d{3})+(\D))\B/g, ".");
      return value;
    },

    phoneMask() {
      return this.payload.telephone && this.payload.telephone.length > 14
        ? "(##) #####-####"
        : "(##) ####-#####?";
    },

    googleAnalytics() {
      const { company_label, vacancy_id } = this.$router.history.current.params;

      company_label && vacancy_id
        ? this.$ga.page(`${company_label}/${vacancy_id}/step/basic-info`)
        : this.$ga.page(`${company_label}/step/basic-info`);
    },

    fetchBasicInfo() {
      this.$vs.loading({
        text: "Carregando...",
      });

      const { company_label } = this.$router.history.current.params;

      this.$http
        .get(`api/v1/talent/${company_label}/user/talent?step=basic`)
        .then((response) => {
          this.$vs.loading.close();
          
          const { basic, talent, professional_profile } = response.data.data;

          let currentValue = 0.00;

          if(professional_profile.intended_remuneration){
            currentValue =  professional_profile.intended_remuneration
          }

          const formatedRemuneration = this.formatCurrency(currentValue.toFixed(2));
          
          this.payload = Object.assign({}, this.payload, {
            ...basic,
            linkedin_url: talent.linkedin_url,
            remuneration: formatedRemuneration
          });

          this.fileUpload = basic.photo_url !== null ? true : false;
          this.CvUploaded = basic.curriculum_url !== null ? true : false;

          // Identify customer
          woopra.identify({
            email: basic.email,
            name: basic.name,
            company: this.$router.history.current.params,
          });

          // track
          // woopra.track();
        })
        .catch((error) => {
          this.$vs.loading.close();
        });
    },
    fetchDiversityOptionsRequest() {
      this.$vs.loading();

      this.$http
        .get("/api/v1/diversity?debug=true")
        .then((response) => {
          const { data = [] } = response;

          const dataKeys = keys(data);

          const options = {};
          
          dataKeys.forEach((key) => {
            set(
              options,
              key,
              data[key].map((item) => ({
                label: item.name,
                value: item.id,
                description: item.description ? item.description : null,
              }))
            );
          });

          const { pronoun, social_name } = this.$store.state.diversity;

          this.include_social_name = isEmpty(social_name) ? false : true;

          set(this.payload, 'social_name', social_name);
          
          if (pronoun && pronoun.id) {
            set(this.payload, 'pronoun_id', pronoun.id);
          }

          this.pronouns = get(options, "pronouns", []);
          this.$vs.loading.close();
        })
        .catch(() => {
          this.$vs.loading.close();
        });
    },
  },
  created() {
    this.$validator.extend("telephone", {
      getMessage: (field) =>
        `O ${field == "telephone" ? "telefone" : field} informado não é válido.`,
      validate: (value) => {
        const telephoneReg = /\(\d{2,}\) \d{4,}\-\d{4}/;
        return value.match(telephoneReg) || false;
      },
    });
    this.$validator.extend("cpf", {
      getMessage: (field) => `O ${field} informada não é valido`,
      validate: (value) => {
        const cpfReg = /[0-9]{3}\.?[0-9]{3}\.?[0-9]{3}\-?[0-9]{2}/;
        if (!value.match(cpfReg)) return false;

        const replaced = value.replace(/\./g, "").replace(/\-/g, "");

        let sum = 0;
        let rest = 0;

        for (let i = 1; i <= 9; i++)
          sum += parseInt(replaced.substring(i - 1, i)) * (11 - i);
        rest = (sum * 10) % 11;

        if (rest == 10 || rest == 11) rest = 0;
        if (rest != parseInt(replaced.substring(9, 10))) return false;

        sum = 0;

        for (let i = 1; i <= 10; i++)
          sum += parseInt(replaced.substring(i - 1, i)) * (12 - i);
        rest = (sum * 10) % 11;

        if (rest == 10 || rest == 11) rest = 0;
        if (rest != parseInt(replaced.substring(10, 11))) return false;

        return true;
      },
    });
    this.$validator.extend("birthday", {
      getMessage: (field, params, data) =>
        (data && data.message) || "Erro não encontrado",
      validate: (value) => {
        return new Promise((resolve) => {
          const splitDate = value.split("/");

          const dayReg = /(0[1-9]|[12]\d|3[01])/;
          const monthReg = /0[1-9]|1[0-2]/;
          const yearReg = /(?:(?:19|20)[0-9]{2})/;

          if (!splitDate[0].match(dayReg))
            resolve({
              valid: false,
              data: {
                message: `O dia ${splitDate[0]} informado não é válido!`,
              },
            });
          if (!splitDate[1].match(monthReg))
            resolve({
              valid: false,
              data: {
                message: `O mês ${splitDate[1]} informado não é válido!`,
              },
            });
          if (!splitDate[2].match(yearReg))
            resolve({
              valid: false,
              data: {
                message: `O ano ${splitDate[2]} informado não é válido!`,
              },
            });

          resolve({ valid: true, data: "" });
        });
      },
    });
    this.$validator.extend("linkedin_domain", (value) => {
      return value.match(
        /((https?:\/\/)?((www|\w\w)\.)?linkedin\.com\/)((([\w]{2,3})?)|([^\/]+\/(([\w|\d-&#?=])+\/?){1,}))$/
      )
        ? true
        : false;
    });
    this.fileUpload =
      this.basicInfo.photo_url != undefined && this.basicInfo.photo_url != null;

    this.googleAnalytics();

    this.fetchBasicInfo();
    this.fetchDiversityOptionsRequest();

    window.scroll(0, 0);

    if (parseInt(updated)) this.uploadedFile();

    if (!parseInt(updated)) this.checkCurriculumUrlBasicInfo();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/talent/views/steps/step.scss";

.file {
  position: relative;
  height: 40px;
  width: 200px;
}

.file > input[type="file"] {
  height: 40px;
  width: 200px;
  position: absoulte;
  opacity: 0;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  cursor: pointer;
}

.file > label {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  color: rgb(32, 100, 178);
  border: 1px solid rgb(32, 100, 178);
  border-radius: 5px;
  line-height: 40px;
  text-align: center;
  cursor: pointer;
}

.revision__container {
  overflow-x: scroll;
}
.warning__container {
  padding: 8px;
  background-color: #ff9f43;
  border-radius: 2px;
  margin-bottom: 16px;

  color: #191919;
}
.warning__title {
  display: flex;
  align-items: center;
  font-weight: 600;
}
.warning__description {
  font-size: 12px;
  font-weight: 500;
  margin-top: 8px;

  button {
    padding: 0 !important;
    color: #0000ff !important;
    font-weight: 600 !important;
  }
}

.vs-popup--header {
  background: #fff;
}

.popup-container {
  width: 100%;

  h2 {
    // font-family: "Roboto";
    font-style: normal;
    font-weight: 500;
    font-size: 19px;
    line-height: 23px;
    color: #172b4d;
  }

  p {
    // font-family: "Roboto";
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    color: #172b4d;
  }

  &--image {
    margin: 20px 0;
    display: flex;
    text-align: center;
    justify-content: center;

    img {
      width: 281px;
      height: 288px;
    }

    @media (max-width: 768px) {
      /* Aplique estilos apenas em telas com largura máxima de 768 pixels (dispositivos móveis) */
      img {
        max-width: 161;
        max-height: 168px;
        width: auto;
        height: auto;
      }
    }
  }

  &--actions {
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
